@if (booking(); as b) {
<div class="detail" [class.detail--embedded]="embedded()">
  @if (isReviewMode() && review()?.message; as m) {
    <p class="detail__intro">{{ m }}</p>
  }
  @if (isConfirmationMode() && confirmation()?.message; as m) {
    <p class="detail__intro">{{ m }}</p>
  }
  @if (isCancellationMode() && cancellation()?.message; as m) {
    <p class="detail__intro">{{ m }}</p>
  }
  @if (isWaitlistReviewMode() && waitlistReview()?.message; as m) {
    <p class="detail__intro">{{ m }}</p>
  }
  @if (isWaitlistConfirmationMode() && waitlistConfirmation()?.message; as m) {
    <p class="detail__intro">{{ m }}</p>
  }
  @if (isAlertConfirmationMode() && alertConfirmation()?.message; as m) {
    <p class="detail__intro">{{ m }}</p>
  }
  <article class="detail__card">
    <header class="detail__summary-header detail__summary-header--{{ headerColorModifier() }}"
            [style.background]="headerColorStyle()">
      <strong>{{ headerTitle() }}</strong>
    </header>

    <div class="detail__body">
      @if (!prepayActive()) {
        <h1 class="detail__course">
          {{ b.courseName }}
          @if (b.location) {
            <span class="detail__course-sub">{{ b.location }}</span>
          }
        </h1>

        <section class="detail__section">
          <h2 class="detail__section-title">Tee Time</h2>
          <ul class="detail__meta">
            <li><span aria-hidden="true">🕒</span> {{ b.time }}</li>
            <li><span aria-hidden="true">📆</span> {{ b.date | date:'EEE. d MMM yyyy' }}</li>
            <li><span aria-hidden="true">🏌️‍♂️</span> {{ b.players.length }} players</li>
            @if (b.holes) {
              <li><span aria-hidden="true">⛳️</span> {{ b.holes }} Holes</li>
            }
          </ul>
        </section>
      }

      @if (b.isWaitlist && (b.expiresAt || b.expiresInDays != null)) {
        <section class="detail__section">
          <h2 class="detail__section-title">Waitlist details</h2>
          <ul class="detail__meta">
            <li>
              <span aria-hidden="true">⏳</span>
              @if (b.expiresAt) {
                Expires {{ b.expiresAt | date:'EEE. d MMM yyyy' }}
                @if (b.expiresInDays != null) {
                  ({{ b.expiresInDays }} {{ b.expiresInDays === 1 ? 'day' : 'days' }})
                }
              } @else {
                Expires in {{ b.expiresInDays }} {{ b.expiresInDays === 1 ? 'day' : 'days' }}
              }
            </li>
          </ul>
        </section>
      }

      @if (!prepayActive() && b.contact; as contact) {
      <section class="detail__section">
        <h2 class="detail__section-title">Your details</h2>
        <div class="detail__contact">
          <span class="detail__contact-avatar">
            @if (contactAvatarUrl(); as avatar) {
              <img [src]="avatar" [alt]="contact.name || ''" width="32" height="32" (error)="onAvatarError()">
            } @else {
              <img src="assets/images/userAvatarIcon.svg" alt="" width="32" height="32">
            }
          </span>
          @if (contact.name) {
            <span class="detail__contact-name">{{ contact.name }}</span>
          }
        </div>

        @if (contact.email) {
        <div class="detail__field">
          <span class="detail__field-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.6" />
              <path d="m3 7 9 6 9-6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          <span>{{ contact.email }}</span>
        </div>
        }

        @if (contact.phone) {
        <div class="detail__field">
          <span class="detail__field-icon" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
            </svg>
          </span>
          <span>{{ contact.phone }}</span>
        </div>
        }
      </section>
      }

      @if (!prepayActive() && (b.costLines?.length || b.bookingFee || b.totalPaid)) {
      <section class="detail__section">
        <h2 class="detail__section-title">Cost Summary</h2>
        <ul class="detail__cost">
          @for (line of b.costLines; track $index) {
            <li>
              <span class="detail__cost-label">{{ line.label }}</span>
              <span class="detail__cost-amount">{{ line.amount | currency:'USD':'symbol':'1.2-2' }}</span>
            </li>
          }
          @if (b.bookingFee !== undefined) {
            <li>
              <span class="detail__cost-label">Booking fee</span>
              <span class="detail__cost-amount detail__cost-amount--muted">{{ b.bookingFee | currency:'USD':'symbol':'1.2-2' }}</span>
            </li>
          }
        </ul>
        @if (b.totalPaid !== undefined) {
          <div class="detail__total">
            <span class="detail__total-label">{{ isReviewMode() ? 'Total Due' : 'Total Paid' }}</span>
            <span class="detail__total-amount">{{ b.totalPaid | currency:'USD':'symbol':'1.2-2' }}</span>
          </div>
        }
      </section>
      }

      @if (b.confirmationCode) {
        <p class="detail__code">
          <strong>Confirmation code</strong><br>
          {{ b.confirmationCode }}
        </p>
      }

      @if (isWaitlistConfirmationMode() && waitlistConfirmation(); as c) {
        @if (c.expiresAt || c.paymentType || c.confirmedBookingId) {
          <section class="detail__section">
            <h2 class="detail__section-title">Waitlist details</h2>
            <ul class="detail__meta">
              @if (c.paymentType) {
                <li><span aria-hidden="true">💳</span> {{ waitlistPaymentLabel(c.paymentType) }}</li>
              }
              @if (c.expiresAt && c.status === 'waitlisted') {
                <li>
                  <span aria-hidden="true">⏳</span>
                  Expires {{ c.expiresAt | date:'EEE. d MMM yyyy' }}
                  @if (c.expiresInDays != null) {
                    ({{ c.expiresInDays }} {{ c.expiresInDays === 1 ? 'day' : 'days' }})
                  }
                </li>
              }
              @if (c.confirmedBookingId) {
                <li><span aria-hidden="true">✅</span> Auto-booked · Booking #{{ c.confirmedBookingId }}</li>
              }
            </ul>
          </section>
        }
        @if (c.nextSteps?.length) {
          <section class="detail__next-card">
            <header class="detail__next-header">
              <span class="detail__next-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2v3M12 19v3M4.93 4.93l2.12 2.12M16.95 16.95l2.12 2.12M2 12h3M19 12h3M4.93 19.07l2.12-2.12M16.95 7.05l2.12-2.12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                  <circle cx="12" cy="12" r="3.5" stroke="currentColor" stroke-width="1.6" />
                </svg>
              </span>
              <h2 class="detail__next-title">What's next</h2>
            </header>
            <ul class="detail__next-steps">
              @for (step of c.nextSteps; track $index) {
                <li>
                  <span class="detail__next-check" aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path d="m5 12 5 5L20 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span>{{ step }}</span>
                </li>
              }
            </ul>
          </section>
        }
        @if (c.referenceId) {
          <p class="detail__code">
            <strong>Reference ID</strong><br>
            {{ c.referenceId }}
          </p>
        }
        @if (c.waitlistId) {
          <p class="detail__code">
            <strong>Waitlist ID</strong><br>
            {{ c.waitlistId }}
          </p>
        }
      }

      @if (isAlertConfirmationMode() && alertConfirmation(); as a) {
        @if (a.expiresAt || a.notifiedAt || a.notificationChannel) {
          <section class="detail__section">
            <h2 class="detail__section-title">Alert details</h2>
            <ul class="detail__meta">
              @if (a.notificationChannel === 'sms') {
                <li><span aria-hidden="true">📱</span> SMS notification</li>
              }
              @if (a.notifiedAt) {
                <li><span aria-hidden="true">✅</span> Notified {{ a.notifiedAt | date:'EEE. d MMM yyyy, h:mm a' }}</li>
              } @else if (a.expiresAt && a.status === 'active') {
                <li>
                  <span aria-hidden="true">⏳</span>
                  Expires {{ a.expiresAt | date:'EEE. d MMM yyyy' }}
                </li>
              }
            </ul>
          </section>
        }
        @if (a.nextSteps?.length) {
          <section class="detail__next-card">
            <header class="detail__next-header">
              <span class="detail__next-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2v3M12 19v3M4.93 4.93l2.12 2.12M16.95 16.95l2.12 2.12M2 12h3M19 12h3M4.93 19.07l2.12-2.12M16.95 7.05l2.12-2.12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                  <circle cx="12" cy="12" r="3.5" stroke="currentColor" stroke-width="1.6" />
                </svg>
              </span>
              <h2 class="detail__next-title">What's next</h2>
            </header>
            <ul class="detail__next-steps">
              @for (step of a.nextSteps; track $index) {
                <li>
                  <span class="detail__next-check" aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path d="m5 12 5 5L20 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span>{{ step }}</span>
                </li>
              }
            </ul>
          </section>
        }
        @if (a.referenceId) {
          <p class="detail__code">
            <strong>Reference ID</strong><br>
            {{ a.referenceId }}
          </p>
        }
        @if (a.alertId) {
          <p class="detail__code">
            <strong>Alert ID</strong><br>
            {{ a.alertId }}
          </p>
        }
      }

      @if (isConfirmationMode() && !prepayActive() && confirmation(); as c) {
        @if (c.nextSteps?.length) {
          <section class="detail__next-card">
            <header class="detail__next-header">
              <span class="detail__next-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2v3M12 19v3M4.93 4.93l2.12 2.12M16.95 16.95l2.12 2.12M2 12h3M19 12h3M4.93 19.07l2.12-2.12M16.95 7.05l2.12-2.12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                  <circle cx="12" cy="12" r="3.5" stroke="currentColor" stroke-width="1.6" />
                </svg>
              </span>
              <h2 class="detail__next-title">What's next</h2>
            </header>
            <ul class="detail__next-steps">
              @for (step of c.nextSteps; track $index) {
                <li>
                  <span class="detail__next-check" aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path d="m5 12 5 5L20 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span>{{ step }}</span>
                </li>
              }
            </ul>
          </section>
        }
        @if (c.referenceId) {
          <p class="detail__code">
            <strong>Reference ID</strong><br>
            {{ c.referenceId }}
          </p>
        }
        @if (c.bookingId) {
          <p class="detail__code">
            <strong>Booking ID</strong><br>
            {{ c.bookingId }}
          </p>
        }
      }

      @if (isCancellationMode() && cancellation(); as c) {
        @if (c.nextSteps?.length) {
          <section class="detail__next-card">
            <header class="detail__next-header">
              <span class="detail__next-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M12 2v3M12 19v3M4.93 4.93l2.12 2.12M16.95 16.95l2.12 2.12M2 12h3M19 12h3M4.93 19.07l2.12-2.12M16.95 7.05l2.12-2.12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                  <circle cx="12" cy="12" r="3.5" stroke="currentColor" stroke-width="1.6" />
                </svg>
              </span>
              <h2 class="detail__next-title">What's next</h2>
            </header>
            <ul class="detail__next-steps">
              @for (step of c.nextSteps; track $index) {
                <li>
                  <span class="detail__next-check" aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path d="m5 12 5 5L20 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                  </span>
                  <span>{{ step }}</span>
                </li>
              }
            </ul>
          </section>
        }
        @if (c.cancelledAt) {
          <p class="detail__code">
            <strong>Cancelled at</strong><br>
            {{ c.cancelledAt | date:'EEE. d MMM yyyy, h:mm a' }}
          </p>
        }
        @if (c.referenceId) {
          <p class="detail__code">
            <strong>Reference ID</strong><br>
            {{ c.referenceId }}
          </p>
        }
        @if (c.bookingId) {
          <p class="detail__code">
            <strong>Booking ID</strong><br>
            {{ c.bookingId }}
          </p>
        }
      }

      @if (isReviewMode()) {
        @if (paymentOptions().length) {
          <fieldset class="detail__payment-options">
            <legend class="detail__section-title">Payment</legend>
            @for (opt of paymentOptions(); track opt.id) {
              <label class="detail__payment-option" [class.detail__payment-option--disabled]="!opt.available">
                <input
                  type="radio"
                  name="paymentOption"
                  class="detail__payment-radio"
                  [value]="opt.id"
                  [checked]="selectedPaymentId() === opt.id"
                  [disabled]="!opt.available || !interactive()"
                  (change)="selectPaymentOption(opt.id)"
                />
                <span class="detail__payment-body">
                  <span class="detail__payment-label">{{ opt.label }}</span>
                  @if (opt.description) {
                    <span class="detail__payment-description">{{ opt.description }}</span>
                  }
                </span>
              </label>
            }
          </fieldset>
        }
        @if (interactive()) {
          <button type="button" class="detail__rebook" [disabled]="submitted()" (click)="confirmBooking()">Confirm</button>
        }
      } @else if (isWaitlistReviewMode()) {
        @if (interactive()) {
          <button type="button" class="detail__rebook" [disabled]="submitted()" (click)="confirmWaitlist()">Add me to the waitlist</button>
        }
      } @else if (isWaitlistConfirmationMode()) {
        @if (canCancelWaitlist() && interactive()) {
          <button type="button" class="detail__cancel detail__cancel--center" [disabled]="submitted()" (click)="cancelWaitlist()">Remove from waitlist</button>
        }
      } @else if (isAlertConfirmationMode()) {
        @if (canCancelAlert() && interactive()) {
          <button type="button" class="detail__cancel detail__cancel--center" [disabled]="submitted()" (click)="cancelAlert()">Cancel notification</button>
        }
      } @else if (isConfirmationMode()) {
        @if (showPaymentBlock() && paymentBlock(); as pay) {
          <app-payment-block
            [payment]="pay"
            [bookingId]="confirmation()?.bookingId"
            [interactive]="interactive()"
            (paymentChange)="onPaymentChange($event)"
            (resolved)="onPaymentResolved($event)"
            (retry)="onRetryPayment()"
          />
        }
        @if (canCancelConfirmation() && interactive() && paymentStatus() !== 'pending') {
          <button type="button" class="detail__cancel detail__cancel--center" [disabled]="submitted()" (click)="cancelBooking()">Cancel booking</button>
        }
      } @else if (isCancellationMode()) {
        <!-- no action buttons in cancellation mode -->
      } @else if (b.isWaitlist) {
        <!-- Route mode for a waitlist row — no receipt, no rebook; only allow removing an active entry. -->
        @if (b.cancellationPolicy) {
          <p class="detail__policy">
            <strong>Cancellation policy</strong><br>
            {{ b.cancellationPolicy }}
          </p>
        }
        @if (canRemoveFromWaitlistRoute()) {
          <button type="button" class="detail__cancel detail__cancel--center" [disabled]="submitted()" (click)="removeFromWaitlistRoute()">Remove from waitlist</button>
        }
      } @else if (b.isAlert) {
        <!-- Route mode for an alert row — SMS notify-only, no receipt or rebook. Cancel only when still active. -->
        @if (canCancelAlertRoute()) {
          <button type="button" class="detail__cancel detail__cancel--center" [disabled]="submitted()" (click)="cancelAlertRoute()">Cancel notification</button>
        }
      } @else {
        <button type="button" class="detail__receipt" (click)="downloadReceipt()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M6 3h9l3 3v15H6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
            <path d="M9 9h6M9 13h6M9 17h4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
          </svg>
          Download Receipt
        </button>

        @if (b.cancellationPolicy) {
          <p class="detail__policy">
            <strong>Cancellation policy</strong><br>
            {{ b.cancellationPolicy }}
          </p>
        }

        @if (canCancelBooking()) {
          <button type="button" class="detail__cancel" [disabled]="submitted()" (click)="cancelBooking()">Cancel booking</button>
        }

        <button type="button" class="detail__rebook" (click)="bookAgain()">Book again</button>
      }
    </div>
  </article>
</div>
} @else if (loading()) {
  <div class="detail__loading" role="status" aria-live="polite">
    <img src="assets/images/send-loader.svg" alt="" width="48" height="48">
    <span class="visually-hidden">Loading booking…</span>
  </div>
} @else {
  <p class="detail__missing">Booking not found.</p>
}

